import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CivilServantBranch  {
    _originalTypeClassName = "zERP.BO.CivilServantBranch";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CivilServantBranch.translate = translateService;
}
this.Speciality = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
PayRollCategory:any;
Speciality:any;
static setPayRollCategory = ($this, value) => {
var oldValue = $this.PayRollCategory;
$this.PayRollCategory = value;
if (value != null) {
}
}
static setSpeciality = ($this, items) => {
                if (items == null) items = [];
                if ($this.Speciality == null) $this.Speciality = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Speciality.length > 0) {
                    Domain.CivilServantBranch.removeSpeciality($this, $this.Speciality[0]);
                }

                Domain.CivilServantBranch.addManySpeciality($this, copyItems);
            }
static addManySpeciality = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CivilServantBranch.addSpeciality($this, items[i]);
                }
            }
static addSpeciality = ($this, item) => {
                if ($this.Speciality == null) $this.Speciality = [];
                if (item == null || $this.Speciality.indexOf(item) > -1) return;
                $this.Speciality.push(item);
if (item.Branch != $this) {
Domain.CivilServantSpeciality.setBranch(item, $this);
}
}
static addRangeSpeciality = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CivilServantBranch.addSpeciality($this, item));
            }
static removeSpeciality = ($this, item) => {
                if ($this == null || $this.Speciality == null || $this.Speciality.indexOf(item) === -1) return;
                var _index = $this.Speciality.indexOf(item);
                $this.Speciality.splice(_index, 1);
item.Branch = null;
}
static clearSpeciality = ($this) => { $this.Speciality = null; }

static GetClassName(): any{return "CivilServantBranch";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}